// removed by extract-text-webpack-plugin
module.exports = {"labelTimeTo":"rio2016-1EPJ- rio2016-2Cex8 rio2016-KJQB4","iconTime":"rio2016-1kXGl"};


/*****************
 ** WEBPACK FOOTER
 ** ./styles/timeTo.css
 ** module id = 294
 ** module chunks = 0 1 2 3 4
 **/